@if (!hideHeader) {
  <div class="layout-fr-auto align-items-center">
    <div class="text-10 bold-700 px-3 py-2 uppercase flex align-items-center" [ngClass]="titleStyleClass">
      {{ headline }}
      @if (infoModalText) {
        <shared-icon class="fill-dark pointer ml-1" icon="info-square" width="1.25rem" height="1.25rem" (click)="showInfoModal()" />
      }
    </div>
    <div>
      <ng-content select="[headerContent]" />
    </div>
  </div>
}

<div class="border-radius-3 overflow-hidden" [ngClass]="contentStyleClass">
  <ng-content />
</div>
